import React from 'react';
import { Button, Modal, Spinner, Table } from 'flowbite-react';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    data: Record<string, string>[];
    keys: string[];
    header?: string;
    isLoading?: boolean;
    handleSubmit: (data: Record<string, string>[]) => void;
};

const AddUsersConfirmationModal = ({ isOpen, onClose, keys, data, handleSubmit, header, isLoading }: Props) => {
    const onSubmit = () => {
        handleSubmit(data);
        onClose();
    };

    if (isOpen) {
        return (
            <Modal dismissible={true} show={isOpen} onClose={onClose} size="4xl">
                <Modal.Header className="bg-blue-50">{header || 'NEW USERS'}</Modal.Header>
                <Modal.Body>
                    <div className="max-w-full whitespace-pre grid grid-cols-1 overflow-auto">
                        <Table striped={true}>
                            <Table.Head>
                                {keys.map((keyName, index) => (
                                    <Table.HeadCell key={index} className="uppercase">
                                        {keyName}
                                    </Table.HeadCell>
                                ))}
                            </Table.Head>
                            <Table.Body>
                                {data.map((user, index) => (
                                    <Table.Row key={index}>
                                        {keys.map((keyName, i) => (
                                            <Table.Cell key={i}>{user[keyName]}</Table.Cell>
                                        ))}
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-full flex flex-row-reverse">
                        <Button className="w-[145px]" color="success" onClick={onSubmit} disabled={isLoading}>
                            {isLoading ? <Spinner /> : 'Confirm'}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    } else return <div />;
};

export default AddUsersConfirmationModal;
